import React, { useState, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { useSearchParams } from "react-router-dom";

import {
  gmailGetMailboxes,
  gmailGetLoginUrl,
  gmailSaveMailbox,
  gmailDeleteMailbox,
} from "@/store/gmail";

import AppBox from "@/components/AppBox";
import AppInput from "@/components/AppInput";
import AppButton from "@/components/AppButton";
import AppLoader from "@/components/AppLoader";
import MailboxesTable from "@/components/Tables/MailboxesTable";

interface AddMailboxModalProps {
  authCode: string;
  onMaliboxSaved: () => void;
}

const AddMailboxModal: React.FC<AddMailboxModalProps> = ({
  authCode,
  onMaliboxSaved,
}) => {
  const dispatch = useAppDispatch();
  const [searchParams, setSearchParams] = useSearchParams();

  const { mailboxes, loginUrl, status, mailboxesStatus } = useAppSelector((state) => state.gmail);

  const [form, setForm] = useState({
    mailbox: "glstexter@gmail.com",
    code: authCode || "",
  });

  // Fetch login URL and mailboxes on mount
  useEffect(() => {
    dispatch(gmailGetLoginUrl());
    dispatch(gmailGetMailboxes());
  }, [dispatch]);

  // Save mailbox if auth code is provided
  useEffect(() => {
    if (authCode) {
      handleSaveMailbox();
    }
  }, [authCode]);

  const handleSaveMailbox = async () => {
    await dispatch(gmailSaveMailbox(form)).unwrap();
    setSearchParams("");
    setForm({ mailbox: "", code: "" });
    dispatch(gmailGetMailboxes());
    onMaliboxSaved();
  };

  const handleDeleteMailbox = async (mailbox: string) => {
    await dispatch(gmailDeleteMailbox(mailbox));
    dispatch(gmailGetMailboxes());
  };

  const handleGetAuthCode = () => {
    if (loginUrl) {
      window.open(loginUrl, '_blank');
    }
  }

  return (
    <AppBox column gap={4} fullWidth>
      {form.code && (
        <AppBox column gap={4}>
          <AppInput
            type="text"
            label="Auth Code"
            value={form.code}
            disabled
          />
          <AppInput
            type="email"
            label="Email"
            fullWidth
            value={form.mailbox}
            onChange={(e) => setForm({ ...form, mailbox: e.target.value })}
          />
        </AppBox>
      )}
      {!authCode && (
        <AppButton
          onClick={handleGetAuthCode}
          isLoading={status === "loading"}
        >
          Get Auth Code
        </AppButton>
      )}
      {mailboxesStatus === "loading" ? (
        <AppBox fullWidth center height={120}>
          <AppLoader />
        </AppBox>
      ) : (
        <MailboxesTable tableRows={mailboxes} onDelete={handleDeleteMailbox} />
      )}
    </AppBox>
  );
};

export default AddMailboxModal;